var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoldDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.905,
    height: 14.905,
    viewBox: "0 0 14.905 14.905",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Arrow---Down-Square",
    "data-name": "Iconly/Bold/Arrow---Down-Square",
    transform: "translate(-0.479 -0.479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow---Down-Square",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42160",
    "data-name": "Path 42160",
    d: "M10.68,0a4.09,4.09,0,0,1,4.226,4.4h0v6.089a4.092,4.092,0,0,1-4.226,4.412H4.218A4.087,4.087,0,0,1,0,10.493H0V4.4A4.085,4.085,0,0,1,4.218,0H10.68ZM7.453,3.853a.554.554,0,0,0-.559.559h0V9.144L5.053,7.3a.572.572,0,0,0-.395-.164.587.587,0,0,0-.395.164.562.562,0,0,0,0,.79h0L7.058,10.9a.577.577,0,0,0,.79,0h0l2.795-2.81a.562.562,0,0,0,0-.79.571.571,0,0,0-.8,0h0L8.012,9.144V4.412A.558.558,0,0,0,7.453,3.853Z",
    transform: "translate(-1.521 -1.521)",
    fill: "#21554e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldDownArrow);
export default __webpack_public_path__ + "static/media/BoldDownArrow.42811b5ef7454ce4d518f391be251b23.svg";
export { ForwardRef as ReactComponent };